import React from 'react';

function FormObjectList({
    objectCount,
    objects,
    keyExtractor,
    render
}) {

    function renderObjects() {
        return objects.map((item, index) => (
            <div key={keyExtractor(index)}>
                {render(index)}
            </div>
        ));
    }

    return (
        <div>
            {renderObjects()}
        </div>
    );
}

export default FormObjectList;